import React, { useState } from 'react';
import {
  CContainer,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderToggler,
  CNavItem,
  CNavLink,
  CFooter,
  CLink
} from '@coreui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import CIcon from '@coreui/icons-react';
import { cilSpeedometer, cilPeople, cilCarAlt, cilListRich, cilSettings, cilAccountLogout } from '@coreui/icons';
import Logo from '../components/Logo';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navigation = [
    {
      component: CNavItem,
      name: t('dashboard.title'),
      to: '/admin',
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: t('admin.users'),
      to: '/admin/users',
      icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: t('admin.carpools'),
      to: '/admin/carpools',
      icon: <CIcon icon={cilCarAlt} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: t('admin.rides'),
      to: '/admin/rides',
      icon: <CIcon icon={cilListRich} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: t('profile.settings'),
      to: '/admin/settings',
      icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    },
  ];

  return (
    <div className="admin-layout">
      <CSidebar
        visible={sidebarVisible}
        onVisibleChange={(visible) => setSidebarVisible(visible)}
      >
        <CSidebarBrand>
          <div className="admin-logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Logo size={32} />
            <div>
              <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{t('common.appName')}</div>
              <div style={{ fontSize: '12px', color: '#6c757d' }}>{t('admin.adminPanel')}</div>
            </div>
          </div>
        </CSidebarBrand>
        <CSidebarNav>
          {navigation.map((item, index) => {
            const NavComponent = item.component;
            const isActive = location.pathname === item.to;
            return (
              <NavComponent key={index}>
                <CNavLink 
                  href="#"
                  active={isActive}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(item.to);
                  }}
                >
                  {item.icon}
                  {item.name}
                </CNavLink>
              </NavComponent>
            );
          })}
        </CSidebarNav>
        <CSidebarToggler />
      </CSidebar>
      
      <div className="admin-wrapper">
        <CHeader>
          <CHeaderToggler
            onClick={() => setSidebarVisible(!sidebarVisible)}
            className="ps-1"
          />
          <CHeaderBrand className="mx-auto d-md-none">
            <CIcon icon={cilSpeedometer} height={48} alt="Logo" />
          </CHeaderBrand>
          <CHeaderNav className="ms-3">
            <CNavItem>
              <CNavLink onClick={() => navigate('/dashboard')}>
                {t('common.backToApp') || 'Back to App'}
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink onClick={handleLogout}>
                <CIcon icon={cilAccountLogout} className="me-2" />
                {t('auth.logout')}
              </CNavLink>
            </CNavItem>
          </CHeaderNav>
        </CHeader>
        
        <div className="admin-body">
          <CContainer fluid>
            {children}
          </CContainer>
        </div>
        
        <CFooter>
          <div>
            <span className="ms-1">
              &copy; 2024 {t('common.appName')} Admin Panel
            </span>
          </div>
          <div className="ms-auto">
            <span className="me-1">Powered by</span>
            <CLink href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
              CoreUI
            </CLink>
          </div>
        </CFooter>
      </div>
    </div>
  );
};

export default AdminLayout;

